import React from 'react'
import { BaseFormNode } from './baseFormNode'
import SelectComponent from '../components/select'

export class SelectNode extends BaseFormNode {
  static getType() { return 'select' }

  static clone(node) {
    return new SelectNode({ ...node.__props }, node.__key)
  }

  static importJSON(serializedNode) {
    return new SelectNode(serializedNode.__props)
  }

  exportJSON() {
    return { type: 'select', version: 1, __props: this.__props }
  }

  createDOM() {
    const span = document.createElement('span')
    span.style.display = 'inline'
    span.style.verticalAlign = 'baseline'
    return span
  }

  updateDOM() { return false }

  decorate(editor) {
    return (
      <SelectComponent
        value={this.__props.value}
        options={this.__props.options || ['']}
        placeholder={this.__props.placeholder}
        onChange={val => this.onChange(editor, val)}
      />
    )
  }
}
